import Le, { useState as M, useEffect as ae } from "react";
var xe = { exports: {} }, G = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var We;
function vt() {
  if (We)
    return G;
  We = 1;
  var h = Le, A = Symbol.for("react.element"), O = Symbol.for("react.fragment"), E = Object.prototype.hasOwnProperty, p = h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, k = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(y, u, w) {
    var S, P = {}, I = null, U = null;
    w !== void 0 && (I = "" + w), u.key !== void 0 && (I = "" + u.key), u.ref !== void 0 && (U = u.ref);
    for (S in u)
      E.call(u, S) && !k.hasOwnProperty(S) && (P[S] = u[S]);
    if (y && y.defaultProps)
      for (S in u = y.defaultProps, u)
        P[S] === void 0 && (P[S] = u[S]);
    return { $$typeof: A, type: y, key: I, ref: U, props: P, _owner: p.current };
  }
  return G.Fragment = O, G.jsx = d, G.jsxs = d, G;
}
var K = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function pt() {
  return $e || ($e = 1, process.env.NODE_ENV !== "production" && function() {
    var h = Le, A = Symbol.for("react.element"), O = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), p = Symbol.for("react.strict_mode"), k = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), y = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), S = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), U = Symbol.for("react.offscreen"), X = Symbol.iterator, Q = "@@iterator";
    function oe(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = X && e[X] || e[Q];
      return typeof t == "function" ? t : null;
    }
    var W = h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(e) {
      {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
          r[a - 1] = arguments[a];
        ie("error", e, r);
      }
    }
    function ie(e, t, r) {
      {
        var a = W.ReactDebugCurrentFrame, f = a.getStackAddendum();
        f !== "" && (t += "%s", r = r.concat([f]));
        var v = r.map(function(c) {
          return String(c);
        });
        v.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, v);
      }
    }
    var D = !1, Z = !1, se = !1, le = !1, ce = !1, H;
    H = Symbol.for("react.module.reference");
    function ue(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === E || e === k || ce || e === p || e === w || e === S || le || e === U || D || Z || se || typeof e == "object" && e !== null && (e.$$typeof === I || e.$$typeof === P || e.$$typeof === d || e.$$typeof === y || e.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === H || e.getModuleId !== void 0));
    }
    function fe(e, t, r) {
      var a = e.displayName;
      if (a)
        return a;
      var f = t.displayName || t.name || "";
      return f !== "" ? r + "(" + f + ")" : r;
    }
    function n(e) {
      return e.displayName || "Context";
    }
    function i(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case E:
          return "Fragment";
        case O:
          return "Portal";
        case k:
          return "Profiler";
        case p:
          return "StrictMode";
        case w:
          return "Suspense";
        case S:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case y:
            var t = e;
            return n(t) + ".Consumer";
          case d:
            var r = e;
            return n(r._context) + ".Provider";
          case u:
            return fe(e, e.render, "ForwardRef");
          case P:
            var a = e.displayName || null;
            return a !== null ? a : i(e.type) || "Memo";
          case I: {
            var f = e, v = f._payload, c = f._init;
            try {
              return i(c(v));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var l = Object.assign, x = 0, F, Y, o, j, _, $, q;
    function _e() {
    }
    _e.__reactDisabledLog = !0;
    function Ye() {
      {
        if (x === 0) {
          F = console.log, Y = console.info, o = console.warn, j = console.error, _ = console.group, $ = console.groupCollapsed, q = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: _e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        x++;
      }
    }
    function Ne() {
      {
        if (x--, x === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: l({}, e, {
              value: F
            }),
            info: l({}, e, {
              value: Y
            }),
            warn: l({}, e, {
              value: o
            }),
            error: l({}, e, {
              value: j
            }),
            group: l({}, e, {
              value: _
            }),
            groupCollapsed: l({}, e, {
              value: $
            }),
            groupEnd: l({}, e, {
              value: q
            })
          });
        }
        x < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = W.ReactCurrentDispatcher, ve;
    function ee(e, t, r) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (f) {
            var a = f.stack.trim().match(/\n( *(at )?)/);
            ve = a && a[1] || "";
          }
        return `
` + ve + e;
      }
    }
    var pe = !1, te;
    {
      var Ue = typeof WeakMap == "function" ? WeakMap : Map;
      te = new Ue();
    }
    function Re(e, t) {
      if (!e || pe)
        return "";
      {
        var r = te.get(e);
        if (r !== void 0)
          return r;
      }
      var a;
      pe = !0;
      var f = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var v;
      v = de.current, de.current = null, Ye();
      try {
        if (t) {
          var c = function() {
            throw Error();
          };
          if (Object.defineProperty(c.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(c, []);
            } catch (T) {
              a = T;
            }
            Reflect.construct(e, [], c);
          } else {
            try {
              c.call();
            } catch (T) {
              a = T;
            }
            e.call(c.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (T) {
            a = T;
          }
          e();
        }
      } catch (T) {
        if (T && a && typeof T.stack == "string") {
          for (var s = T.stack.split(`
`), R = a.stack.split(`
`), m = s.length - 1, g = R.length - 1; m >= 1 && g >= 0 && s[m] !== R[g]; )
            g--;
          for (; m >= 1 && g >= 0; m--, g--)
            if (s[m] !== R[g]) {
              if (m !== 1 || g !== 1)
                do
                  if (m--, g--, g < 0 || s[m] !== R[g]) {
                    var C = `
` + s[m].replace(" at new ", " at ");
                    return e.displayName && C.includes("<anonymous>") && (C = C.replace("<anonymous>", e.displayName)), typeof e == "function" && te.set(e, C), C;
                  }
                while (m >= 1 && g >= 0);
              break;
            }
        }
      } finally {
        pe = !1, de.current = v, Ne(), Error.prepareStackTrace = f;
      }
      var V = e ? e.displayName || e.name : "", N = V ? ee(V) : "";
      return typeof e == "function" && te.set(e, N), N;
    }
    function Be(e, t, r) {
      return Re(e, !1);
    }
    function Ve(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function re(e, t, r) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Re(e, Ve(e));
      if (typeof e == "string")
        return ee(e);
      switch (e) {
        case w:
          return ee("Suspense");
        case S:
          return ee("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case u:
            return Be(e.render);
          case P:
            return re(e.type, t, r);
          case I: {
            var a = e, f = a._payload, v = a._init;
            try {
              return re(v(f), t, r);
            } catch {
            }
          }
        }
      return "";
    }
    var z = Object.prototype.hasOwnProperty, we = {}, Se = W.ReactDebugCurrentFrame;
    function ne(e) {
      if (e) {
        var t = e._owner, r = re(e.type, e._source, t ? t.type : null);
        Se.setExtraStackFrame(r);
      } else
        Se.setExtraStackFrame(null);
    }
    function qe(e, t, r, a, f) {
      {
        var v = Function.call.bind(z);
        for (var c in e)
          if (v(e, c)) {
            var s = void 0;
            try {
              if (typeof e[c] != "function") {
                var R = Error((a || "React class") + ": " + r + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              s = e[c](t, c, a, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (m) {
              s = m;
            }
            s && !(s instanceof Error) && (ne(f), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", r, c, typeof s), ne(null)), s instanceof Error && !(s.message in we) && (we[s.message] = !0, ne(f), b("Failed %s type: %s", r, s.message), ne(null));
          }
      }
    }
    var ze = Array.isArray;
    function me(e) {
      return ze(e);
    }
    function Je(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, r = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return r;
      }
    }
    function Ge(e) {
      try {
        return Te(e), !1;
      } catch {
        return !0;
      }
    }
    function Te(e) {
      return "" + e;
    }
    function Ae(e) {
      if (Ge(e))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Je(e)), Te(e);
    }
    var J = W.ReactCurrentOwner, Ke = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ce, Oe, ge;
    ge = {};
    function Xe(e) {
      if (z.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Qe(e) {
      if (z.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ze(e, t) {
      if (typeof e.ref == "string" && J.current && t && J.current.stateNode !== t) {
        var r = i(J.current.type);
        ge[r] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', i(J.current.type), e.ref), ge[r] = !0);
      }
    }
    function He(e, t) {
      {
        var r = function() {
          Ce || (Ce = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        r.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: r,
          configurable: !0
        });
      }
    }
    function et(e, t) {
      {
        var r = function() {
          Oe || (Oe = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        r.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: r,
          configurable: !0
        });
      }
    }
    var tt = function(e, t, r, a, f, v, c) {
      var s = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: A,
        // Built-in properties that belong on the element
        type: e,
        key: t,
        ref: r,
        props: c,
        // Record the component responsible for creating this element.
        _owner: v
      };
      return s._store = {}, Object.defineProperty(s._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(s, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(s, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.freeze && (Object.freeze(s.props), Object.freeze(s)), s;
    };
    function rt(e, t, r, a, f) {
      {
        var v, c = {}, s = null, R = null;
        r !== void 0 && (Ae(r), s = "" + r), Qe(t) && (Ae(t.key), s = "" + t.key), Xe(t) && (R = t.ref, Ze(t, f));
        for (v in t)
          z.call(t, v) && !Ke.hasOwnProperty(v) && (c[v] = t[v]);
        if (e && e.defaultProps) {
          var m = e.defaultProps;
          for (v in m)
            c[v] === void 0 && (c[v] = m[v]);
        }
        if (s || R) {
          var g = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          s && He(c, g), R && et(c, g);
        }
        return tt(e, s, R, f, a, J.current, c);
      }
    }
    var he = W.ReactCurrentOwner, ke = W.ReactDebugCurrentFrame;
    function B(e) {
      if (e) {
        var t = e._owner, r = re(e.type, e._source, t ? t.type : null);
        ke.setExtraStackFrame(r);
      } else
        ke.setExtraStackFrame(null);
    }
    var ye;
    ye = !1;
    function be(e) {
      return typeof e == "object" && e !== null && e.$$typeof === A;
    }
    function Pe() {
      {
        if (he.current) {
          var e = i(he.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function nt(e) {
      {
        if (e !== void 0) {
          var t = e.fileName.replace(/^.*[\\\/]/, ""), r = e.lineNumber;
          return `

Check your code at ` + t + ":" + r + ".";
        }
        return "";
      }
    }
    var je = {};
    function at(e) {
      {
        var t = Pe();
        if (!t) {
          var r = typeof e == "string" ? e : e.displayName || e.name;
          r && (t = `

Check the top-level render call using <` + r + ">.");
        }
        return t;
      }
    }
    function Ie(e, t) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var r = at(t);
        if (je[r])
          return;
        je[r] = !0;
        var a = "";
        e && e._owner && e._owner !== he.current && (a = " It was passed a child from " + i(e._owner.type) + "."), B(e), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, a), B(null);
      }
    }
    function De(e, t) {
      {
        if (typeof e != "object")
          return;
        if (me(e))
          for (var r = 0; r < e.length; r++) {
            var a = e[r];
            be(a) && Ie(a, t);
          }
        else if (be(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var f = oe(e);
          if (typeof f == "function" && f !== e.entries)
            for (var v = f.call(e), c; !(c = v.next()).done; )
              be(c.value) && Ie(c.value, t);
        }
      }
    }
    function ot(e) {
      {
        var t = e.type;
        if (t == null || typeof t == "string")
          return;
        var r;
        if (typeof t == "function")
          r = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === P))
          r = t.propTypes;
        else
          return;
        if (r) {
          var a = i(t);
          qe(r, e.props, "prop", a, e);
        } else if (t.PropTypes !== void 0 && !ye) {
          ye = !0;
          var f = i(t);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", f || "Unknown");
        }
        typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function it(e) {
      {
        for (var t = Object.keys(e.props), r = 0; r < t.length; r++) {
          var a = t[r];
          if (a !== "children" && a !== "key") {
            B(e), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), B(null);
            break;
          }
        }
        e.ref !== null && (B(e), b("Invalid attribute `ref` supplied to `React.Fragment`."), B(null));
      }
    }
    var Fe = {};
    function Me(e, t, r, a, f, v) {
      {
        var c = ue(e);
        if (!c) {
          var s = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (s += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = nt(f);
          R ? s += R : s += Pe();
          var m;
          e === null ? m = "null" : me(e) ? m = "array" : e !== void 0 && e.$$typeof === A ? (m = "<" + (i(e.type) || "Unknown") + " />", s = " Did you accidentally export a JSX literal instead of a component?") : m = typeof e, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", m, s);
        }
        var g = rt(e, t, r, f, v);
        if (g == null)
          return g;
        if (c) {
          var C = t.children;
          if (C !== void 0)
            if (a)
              if (me(C)) {
                for (var V = 0; V < C.length; V++)
                  De(C[V], e);
                Object.freeze && Object.freeze(C);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              De(C, e);
        }
        if (z.call(t, "key")) {
          var N = i(e), T = Object.keys(t).filter(function(dt) {
            return dt !== "key";
          }), Ee = T.length > 0 ? "{key: someKey, " + T.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Fe[N + Ee]) {
            var ft = T.length > 0 ? "{" + T.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ee, N, ft, N), Fe[N + Ee] = !0;
          }
        }
        return e === E ? it(g) : ot(g), g;
      }
    }
    function st(e, t, r) {
      return Me(e, t, r, !0);
    }
    function lt(e, t, r) {
      return Me(e, t, r, !1);
    }
    var ct = lt, ut = st;
    K.Fragment = E, K.jsx = ct, K.jsxs = ut;
  }()), K;
}
process.env.NODE_ENV === "production" ? xe.exports = vt() : xe.exports = pt();
var L = xe.exports;
const mt = ({
  onChange: h,
  placeholder: A,
  value: O,
  onKeyDown: E
}) => /* @__PURE__ */ L.jsx(
  "input",
  {
    type: "text",
    placeholder: A,
    value: O,
    onKeyDown: (p) => E && E(p),
    onChange: (p) => h(p.target.value),
    className: "search-input min-w-full pt-[.5em] pb-[.5em] pr-[1em] pl-[1em] bg-white text-gray-600"
  }
);
const gt = ({
  suggestions: h,
  setSelectedSuggestion: A,
  onMouseEnter: O,
  onMouseLeave: E
}) => /* @__PURE__ */ L.jsx("div", { className: "search-results w-full top-[100%] left-0 right-0 max-h-[25em] absolute bg-white overflow-x-hidden overflow-y-auto text-black z-[5]", children: /* @__PURE__ */ L.jsx("ul", { children: h && h.map((p) => /* @__PURE__ */ L.jsx(
  ht,
  {
    result: p,
    setSelectedSuggestion: A,
    onMouseEnter: O,
    onMouseLeave: E
  }
)) }) }), ht = ({
  result: h,
  setSelectedSuggestion: A,
  onMouseEnter: O,
  onMouseLeave: E
}) => {
  var p, k;
  return /* @__PURE__ */ L.jsxs(
    "li",
    {
      onClick: () => {
        A(h);
      },
      onMouseEnter: () => O(h),
      onMouseLeave: () => E(h),
      className: `item-${h.isActive && "active"} hover:bg-[#2A89C4] hover:text-white hover:cursor-pointer`,
      children: [
        (p = h.mainText) == null ? void 0 : p.text,
        " ",
        (k = h.secondaryText) == null ? void 0 : k.text
      ]
    }
  );
}, bt = ({
  minLength: h = 1,
  country: A = "us",
  placeholder: O,
  onSelectPrediction: E
}) => {
  const [
    p,
    k
  ] = M(null), [d, y] = M(
    []
  ), [u, w] = M(void 0), [S, P] = M(void 0), [I, U] = M(void 0), [X, Q] = M(void 0), [oe, W] = M(void 0), [b, ie] = M(
    void 0
  ), [D, Z] = M("");
  ae(() => {
    if (typeof window > "u")
      return;
    const n = window.google && window.google.maps;
    if (!n) {
      console && console.error("Google maps API was not found in the window.");
      return;
    }
    P(n);
    try {
      const i = new n.places.AutocompleteSuggestion();
      U(i), se(n), W(new n.places.AutocompleteSessionToken()), ie(new n.Geocoder()), console.log(
        "Successfully initialized new Google Maps Places API components"
      );
    } catch (i) {
      console.error("Error initializing Google Maps components:", i);
    }
  }, []);
  const se = (n) => {
    try {
      const i = document.createElement("div");
      i.setAttribute("id", "map"), i.setAttribute("data-place-id", "ChIJd8BlQ2BZwokRAFUEcm_qrcA"), document.body.appendChild(i);
      const l = new n.places.Place(i);
      Q(l), document.body.removeChild(i);
    } catch (i) {
      console.warn(
        "First Place initialization approach failed, trying alternative:",
        i
      );
      try {
        const l = document.createElement("div");
        l.style.display = "none", document.body.appendChild(l);
        const x = new n.Map(l, {
          center: { lat: 0, lng: 0 },
          zoom: 2
        }), F = new n.places.Place(l);
        Q(F), document.body.removeChild(l);
      } catch (l) {
        console.error(
          "All Place initialization approaches failed:",
          l
        );
      }
    }
  };
  ae(() => {
    p || setTimeout(() => {
      le();
    }, 1e3), d && p && D === `${p.formattedAddr}` && (y(null), w(void 0));
  }, [D]), ae(() => {
    var n;
    p !== null && (Z(`${(n = p.text) == null ? void 0 : n.text}`), ce(p));
  }, [p]);
  const le = async () => {
    if (!D || !I) {
      y(null);
      return;
    }
    const n = D.length;
    if (!(h && n < h))
      try {
        const l = {
          input: D,
          sessionToken: oe,
          region: A
        }, x = await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
          l
        );
        if (x.suggestions && x.suggestions.length > 0) {
          const F = x.suggestions.map(
            (Y) => {
              var j, _, $, q;
              const o = Y.placePrediction;
              return {
                // Add required fields from PlacePrediction
                formattedAddr: ((j = o == null ? void 0 : o.toPlace()) == null ? void 0 : j.formattedAddress) ?? "",
                placeId: (o == null ? void 0 : o.placeId) || "",
                mainText: (o == null ? void 0 : o.mainText) || {
                  text: "",
                  matches: ((_ = o == null ? void 0 : o.mainText) == null ? void 0 : _.matches) || []
                },
                secondaryText: (o == null ? void 0 : o.secondaryText) || {
                  text: "",
                  matches: (($ = o == null ? void 0 : o.secondaryText) == null ? void 0 : $.matches) || []
                },
                distanceMeters: (o == null ? void 0 : o.distanceMeters) || 0,
                types: (o == null ? void 0 : o.types) || [],
                matchedSubstrings: (o == null ? void 0 : o.types) || [],
                formattedAddress: (o == null ? void 0 : o.toPlace().formattedAddress) || "",
                // Add isActive property
                isActive: !1,
                text: { text: ((q = o == null ? void 0 : o.text) == null ? void 0 : q.text) || "", matches: [] },
                toPlace: (o == null ? void 0 : o.toPlace) || (() => ({}))
              };
            }
          );
          y(F);
        } else
          y(null);
      } catch (l) {
        console.error("Error getting place suggestions:", l);
        const x = [
          {
            placeId: "ChIJd8BlQ2BZwokRAFUEcm_qrcA",
            // Empire State Building
            mainText: { text: "Fallback: Empire State Building", matches: [] },
            secondaryText: {
              text: "20 W 34th St, New York, NY 10001",
              matches: []
            },
            // primaryText: { text: userInput + ' - Empire State Building', languageCode: 'en' },
            types: ["premise", "tourist_attraction"],
            isActive: !1,
            distanceMeters: 0,
            text: { text: "111", matches: [] },
            toPlace: () => ({}),
            formattedAddr: "123 main street"
          },
          {
            placeId: "ChIJPTacEpBQwokRKwIlDXelxkA",
            // Statue of Liberty
            mainText: {
              text: "Fallback: Statue of Liberty",
              matches: []
            },
            text: { text: "New York, NY 10004", matches: [] },
            secondaryText: {
              text: D + " - Statue of Liberty",
              matches: []
            },
            types: ["premise", "tourist_attraction"],
            isActive: !1,
            distanceMeters: 0,
            toPlace: () => ({}),
            formattedAddr: "456 main street"
          }
        ];
        y(x);
      }
  };
  ae(() => {
    if (u === void 0 && d && d.length > 0) {
      const n = d.map((i, l) => (i.isActive = !1, i));
      y(n);
    }
    if (d && d.length > 0 && (u || u === 0)) {
      const n = d.map((i, l) => (l === u ? i.isActive = !0 : i.isActive = !1, i));
      y(n);
    }
  }, [u]);
  const ce = async (n) => {
    var l, x, F, Y;
    if (!X) {
      console.error("Place service not initialized");
      return;
    }
    if (!n.placeId || n.placeId.trim() === "") {
      console.error("Invalid or empty placeId provided to getPlaceDetails");
      return;
    }
    const i = n.toPlace();
    try {
      const o = {
        fields: [
          "displayName",
          "formattedAddress",
          "location",
          "viewport",
          "types",
          "addressComponents"
        ]
      };
      let j;
      try {
        j = await i.fetchFields(o);
      } catch (_) {
        if (_ !== void 0)
          throw console.warn("Error calling Place.getDetails API:", _), _;
      }
      if (j && j.place) {
        const _ = j.place, $ = {
          ...n,
          placePrediction: _,
          place: n,
          location: {
            lat: ((l = _.location) == null ? void 0 : l.lat()) || 0,
            lng: ((x = _.location) == null ? void 0 : x.lng()) || 0
          },
          formattedAddr: _.formattedAddress || ""
        };
        $ && E && (E($), k(null), w(void 0));
      } else {
        console.error("Error fetching place details:", j.status);
        const _ = {
          id: n.placeId || "ChIJd8BlQ2BZwokRAFUEcm_qrcA",
          // Use suggestion placeId or fallback to a valid ID
          formattedAddress: ((F = n.secondaryText) == null ? void 0 : F.text) || "Address unavailable",
          location: {
            latitude: 37.7749,
            // Default coordinates for San Francisco
            longitude: -122.4194
          },
          displayName: ((Y = n.mainText) == null ? void 0 : Y.text) || {
            text: "Location name unavailable",
            languageCode: "en"
          },
          addressComponents: [
            {
              longText: "Default Street",
              shortText: "St",
              types: ["route"],
              languageCode: "en"
            },
            {
              longText: "Default City",
              shortText: "City",
              types: ["locality"],
              languageCode: "en"
            }
          ],
          types: n.types || ["establishment"],
          viewport: {
            low: {
              latitude: 37.7,
              longitude: -122.5
            },
            high: {
              latitude: 37.8,
              longitude: -122.3
            }
          }
        };
      }
    } catch (o) {
      console.error("Error fetching place details:", o);
    }
  }, H = (n) => {
    if (n.code === "ArrowDown" && d && d.length > 0) {
      if (u === void 0) {
        w(0);
        return;
      }
      if (u !== void 0)
        if (u < d.length - 1) {
          w(u + 1);
          return;
        } else
          return;
    }
    if (n.code === "ArrowUp" && d && d.length > 0) {
      if (u === 0) {
        w(void 0);
        return;
      }
      if (u !== void 0)
        if (u) {
          w(u - 1);
          return;
        } else
          return;
    }
    if (n.code === "Enter" && (u || u === 0) && d && d.length > 0) {
      const i = d[u];
      k(i), w(void 0);
      return;
    }
  }, ue = (n) => {
    const i = d == null ? void 0 : d.map((l) => (l.placeId === n.placeId && (l.isActive = !0), l));
    n.isActive = !0, i && y(i);
  }, fe = (n) => {
    const i = d == null ? void 0 : d.map((l) => (l.placeId === n.placeId && (l.isActive = !1), l));
    i && y(i);
  };
  return /* @__PURE__ */ L.jsxs("div", { className: "text-[24px] relative text-left mt-[1em] mb-[1em] mr-auto ml-auto min-w-[30rem]", children: [
    /* @__PURE__ */ L.jsx(
      mt,
      {
        onChange: (n) => Z(n),
        placeholder: O || "Search Places",
        value: D,
        onKeyDown: (n) => H(n)
      }
    ),
    /* @__PURE__ */ L.jsx(
      gt,
      {
        suggestions: d,
        setSelectedSuggestion: (n) => {
          k(n), y(null);
        },
        onMouseEnter: ue,
        onMouseLeave: fe
      }
    )
  ] });
};
export {
  bt as AutoComplete
};
//# sourceMappingURL=index.es.js.map
